import { render } from "./CollarCufs.vue?vue&type=template&id=3f04dd56&scoped=true"
import script from "./CollarCufs.vue?vue&type=script&lang=js"
export * from "./CollarCufs.vue?vue&type=script&lang=js"

import "./CollarCufs.vue?vue&type=style&index=0&id=3f04dd56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f04dd56"]])

export default __exports__